/*eslint-disable*/
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/infoGeneral`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchInfoGeneral = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  let res = await fetch(readUrl(`/${params}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};
export const fetchInfoGeneralActivitiesByClientId = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  let res = await fetch(readUrl(`/Activity/${params}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};
export const fetchInfoGeneralFilesByClientId = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  let res = await fetch(readUrl(`/files/${params}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};
export const fetchInfoGeneralCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/categories`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
export const patchinfoGeneral = async (clientId, body) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`/${clientId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: body.id, value: body.value }),
  });

  res = await parseJSON(res);

  return res.success;
};
